module.exports = __webpack_public_path__ + "img/sec1_img4.6099131a.png";